/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationQueryKey,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface OfficeDataHealthService {
  /** @summary Get Report */
  getOfficeDataHealth: {
    /** @summary Get Report */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetOfficeDataHealthSchema, GetOfficeDataHealthParameters, TMeta, TSignal>
        | QueryFnOptionsByParameters<GetOfficeDataHealthParameters, TMeta, TSignal>,
      client?: (
        schema: GetOfficeDataHealthSchema,
        options: {
          parameters: GetOfficeDataHealthParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetOfficeDataHealthData, GetOfficeDataHealthError>>
    ): Promise<RequestFnResponse<GetOfficeDataHealthData, GetOfficeDataHealthError>>;
    /** @summary Get Report */
    getQueryKey(
      parameters: DeepReadonly<GetOfficeDataHealthParameters>
    ): ServiceOperationQueryKey<GetOfficeDataHealthSchema, GetOfficeDataHealthParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.officeDataHealthService.getOfficeDataHealth.useQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetOfficeDataHealthData>(
      parameters:
        | ServiceOperationQueryKey<GetOfficeDataHealthSchema, GetOfficeDataHealthParameters>
        | DeepReadonly<GetOfficeDataHealthParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetOfficeDataHealthData,
          GetOfficeDataHealthError,
          TData,
          ServiceOperationQueryKey<GetOfficeDataHealthSchema, GetOfficeDataHealthParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetOfficeDataHealthError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.officeDataHealthService.getOfficeDataHealth.useQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetOfficeDataHealthData>(
      parameters:
        | ServiceOperationQueryKey<GetOfficeDataHealthSchema, GetOfficeDataHealthParameters>
        | DeepReadonly<GetOfficeDataHealthParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetOfficeDataHealthData,
          GetOfficeDataHealthError,
          TData,
          ServiceOperationQueryKey<GetOfficeDataHealthSchema, GetOfficeDataHealthParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetOfficeDataHealthError>>;
    /** @summary Get Report */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetOfficeDataHealthParameters>
    ): ServiceOperationInfiniteQueryKey<GetOfficeDataHealthSchema, GetOfficeDataHealthParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.officeDataHealthService.getOfficeDataHealth.useInfiniteQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetOfficeDataHealthParameters,
      TQueryFnData = GetOfficeDataHealthData,
      TData = OperationInfiniteData<TQueryFnData, GetOfficeDataHealthParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetOfficeDataHealthSchema, GetOfficeDataHealthParameters>
        | DeepReadonly<GetOfficeDataHealthParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetOfficeDataHealthError,
          TData,
          ServiceOperationInfiniteQueryKey<GetOfficeDataHealthSchema, GetOfficeDataHealthParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetOfficeDataHealthError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.officeDataHealthService.getOfficeDataHealth.useInfiniteQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetOfficeDataHealthParameters,
      TQueryFnData = GetOfficeDataHealthData,
      TData = OperationInfiniteData<TQueryFnData, GetOfficeDataHealthParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetOfficeDataHealthSchema, GetOfficeDataHealthParameters>
        | DeepReadonly<GetOfficeDataHealthParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetOfficeDataHealthError,
          TData,
          ServiceOperationInfiniteQueryKey<GetOfficeDataHealthSchema, GetOfficeDataHealthParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetOfficeDataHealthData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetOfficeDataHealthError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getOfficeDataHealthTotal = qraft.officeDataHealthService.getOfficeDataHealth.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getOfficeDataHealthByParametersTotal = qraft.officeDataHealthService.getOfficeDataHealth.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetOfficeDataHealthSchema,
            GetOfficeDataHealthData,
            TInfinite,
            GetOfficeDataHealthParameters,
            GetOfficeDataHealthError
          >
        | QueryFiltersByQueryKey<
            GetOfficeDataHealthSchema,
            GetOfficeDataHealthData,
            TInfinite,
            GetOfficeDataHealthParameters,
            GetOfficeDataHealthError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getOfficeDataHealthResults = qraft.officeDataHealthService.getOfficeDataHealth.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getOfficeDataHealthResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getOfficeDataHealthCombinedResults = qraft.officeDataHealthService.getOfficeDataHealth.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getOfficeDataHealthCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetOfficeDataHealthSchema,
          GetOfficeDataHealthParameters,
          GetOfficeDataHealthData,
          GetOfficeDataHealthError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetOfficeDataHealthData, GetOfficeDataHealthError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<GetOfficeDataHealthData, GetOfficeDataHealthError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.officeDataHealthService.getOfficeDataHealth.useSuspenseQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetOfficeDataHealthData>(
      parameters:
        | ServiceOperationQueryKey<GetOfficeDataHealthSchema, GetOfficeDataHealthParameters>
        | DeepReadonly<GetOfficeDataHealthParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetOfficeDataHealthData,
          GetOfficeDataHealthError,
          TData,
          ServiceOperationQueryKey<GetOfficeDataHealthSchema, GetOfficeDataHealthParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetOfficeDataHealthError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.officeDataHealthService.getOfficeDataHealth.useSuspenseInfiniteQuery({
     *     path: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetOfficeDataHealthParameters, TData = GetOfficeDataHealthData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetOfficeDataHealthSchema, GetOfficeDataHealthParameters>
        | DeepReadonly<GetOfficeDataHealthParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetOfficeDataHealthData,
          GetOfficeDataHealthError,
          OperationInfiniteData<TData, GetOfficeDataHealthParameters>,
          ServiceOperationInfiniteQueryKey<GetOfficeDataHealthSchema, GetOfficeDataHealthParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetOfficeDataHealthData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetOfficeDataHealthParameters>,
      OperationError<GetOfficeDataHealthError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Report
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getOfficeDataHealthData = qraft.officeDataHealthService.getOfficeDataHealth.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getOfficeDataHealthResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getOfficeDataHealthCombinedData = qraft.officeDataHealthService.getOfficeDataHealth.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getOfficeDataHealthCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetOfficeDataHealthSchema,
          GetOfficeDataHealthParameters,
          GetOfficeDataHealthData,
          GetOfficeDataHealthError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetOfficeDataHealthData, GetOfficeDataHealthError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<GetOfficeDataHealthData, GetOfficeDataHealthError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get Report */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetOfficeDataHealthSchema,
        GetOfficeDataHealthData,
        GetOfficeDataHealthParameters,
        GetOfficeDataHealthError
      >
    ): Promise<GetOfficeDataHealthData>;
    /** @summary Get Report */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetOfficeDataHealthSchema,
        GetOfficeDataHealthData,
        GetOfficeDataHealthParameters,
        GetOfficeDataHealthError
      >
    ): Promise<void>;
    /** @summary Get Report */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetOfficeDataHealthSchema,
        GetOfficeDataHealthData,
        GetOfficeDataHealthParameters,
        GetOfficeDataHealthError
      >
    ): Promise<GetOfficeDataHealthData>;
    /** @summary Get Report */
    fetchInfiniteQuery<TPageParam extends GetOfficeDataHealthParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetOfficeDataHealthSchema,
        GetOfficeDataHealthData,
        GetOfficeDataHealthParameters,
        DeepReadonly<TPageParam>,
        GetOfficeDataHealthError
      >
    ): Promise<OperationInfiniteData<GetOfficeDataHealthData, GetOfficeDataHealthParameters>>;
    /** @summary Get Report */
    prefetchInfiniteQuery<TPageParam extends GetOfficeDataHealthParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetOfficeDataHealthSchema,
        GetOfficeDataHealthData,
        GetOfficeDataHealthParameters,
        DeepReadonly<TPageParam>,
        GetOfficeDataHealthError
      >
    ): Promise<void>;
    /** @summary Get Report */
    ensureInfiniteQueryData<TPageParam extends GetOfficeDataHealthParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetOfficeDataHealthSchema,
        GetOfficeDataHealthData,
        GetOfficeDataHealthParameters,
        DeepReadonly<TPageParam>,
        GetOfficeDataHealthError
      >
    ): Promise<OperationInfiniteData<GetOfficeDataHealthData, GetOfficeDataHealthParameters>>;
    /** @summary Get Report */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetOfficeDataHealthSchema, GetOfficeDataHealthParameters>
        | DeepReadonly<GetOfficeDataHealthParameters>
    ): GetOfficeDataHealthData | undefined;
    /** @summary Get Report */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetOfficeDataHealthSchema, GetOfficeDataHealthParameters>
        | DeepReadonly<GetOfficeDataHealthParameters>
    ): OperationInfiniteData<GetOfficeDataHealthData, GetOfficeDataHealthParameters> | undefined;
    /** @summary Get Report */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetOfficeDataHealthSchema,
            GetOfficeDataHealthData,
            TInfinite,
            GetOfficeDataHealthParameters,
            GetOfficeDataHealthError
          >
        | QueryFiltersByQueryKey<
            GetOfficeDataHealthSchema,
            GetOfficeDataHealthData,
            TInfinite,
            GetOfficeDataHealthParameters,
            GetOfficeDataHealthError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetOfficeDataHealthSchema, GetOfficeDataHealthParameters>,
            data: NoInfer<OperationInfiniteData<GetOfficeDataHealthData, GetOfficeDataHealthParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetOfficeDataHealthSchema, GetOfficeDataHealthParameters>,
            data: GetOfficeDataHealthData | undefined,
          ]
        >;
    /** @summary Get Report */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetOfficeDataHealthSchema, GetOfficeDataHealthParameters>
        | DeepReadonly<GetOfficeDataHealthParameters>
    ): QueryState<GetOfficeDataHealthData, GetOfficeDataHealthError> | undefined;
    /** @summary Get Report */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetOfficeDataHealthParameters>
        | ServiceOperationInfiniteQueryKey<GetOfficeDataHealthSchema, GetOfficeDataHealthParameters>
    ):
      | QueryState<
          OperationInfiniteData<GetOfficeDataHealthData, GetOfficeDataHealthParameters>,
          GetOfficeDataHealthError
        >
      | undefined;
    /** @summary Get Report */
    setQueryData(
      parameters:
        | DeepReadonly<GetOfficeDataHealthParameters>
        | ServiceOperationQueryKey<GetOfficeDataHealthSchema, GetOfficeDataHealthParameters>,
      updater: Updater<
        NoInfer<GetOfficeDataHealthData> | undefined,
        NoInfer<DeepReadonly<GetOfficeDataHealthData>> | undefined
      >,
      options?: SetDataOptions
    ): GetOfficeDataHealthData | undefined;
    /** @summary Get Report */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetOfficeDataHealthParameters>
        | ServiceOperationInfiniteQueryKey<GetOfficeDataHealthSchema, GetOfficeDataHealthParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetOfficeDataHealthData, GetOfficeDataHealthParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<GetOfficeDataHealthData, GetOfficeDataHealthParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetOfficeDataHealthData, GetOfficeDataHealthParameters> | undefined;
    /** @summary Get Report */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetOfficeDataHealthSchema,
            GetOfficeDataHealthData,
            TInfinite,
            GetOfficeDataHealthParameters,
            GetOfficeDataHealthError
          >
        | QueryFiltersByQueryKey<
            GetOfficeDataHealthSchema,
            GetOfficeDataHealthData,
            TInfinite,
            GetOfficeDataHealthParameters,
            GetOfficeDataHealthError
          >,
      updater: Updater<NoInfer<GetOfficeDataHealthData> | undefined, NoInfer<GetOfficeDataHealthData> | undefined>,
      options?: SetDataOptions
    ): Array<GetOfficeDataHealthData | undefined>;
    /** @summary Get Report */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetOfficeDataHealthSchema,
        GetOfficeDataHealthData,
        TInfinite,
        GetOfficeDataHealthParameters,
        GetOfficeDataHealthError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get Report */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetOfficeDataHealthSchema,
            GetOfficeDataHealthData,
            TInfinite,
            GetOfficeDataHealthParameters,
            GetOfficeDataHealthError
          >
        | QueryFiltersByQueryKey<
            GetOfficeDataHealthSchema,
            GetOfficeDataHealthData,
            TInfinite,
            GetOfficeDataHealthParameters,
            GetOfficeDataHealthError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get Report */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetOfficeDataHealthSchema,
            GetOfficeDataHealthData,
            TInfinite,
            GetOfficeDataHealthParameters,
            GetOfficeDataHealthError
          >
        | QueryFiltersByQueryKey<
            GetOfficeDataHealthSchema,
            GetOfficeDataHealthData,
            TInfinite,
            GetOfficeDataHealthParameters,
            GetOfficeDataHealthError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get Report */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetOfficeDataHealthSchema,
            GetOfficeDataHealthData,
            TInfinite,
            GetOfficeDataHealthParameters,
            GetOfficeDataHealthError
          >
        | QueryFiltersByQueryKey<
            GetOfficeDataHealthSchema,
            GetOfficeDataHealthData,
            TInfinite,
            GetOfficeDataHealthParameters,
            GetOfficeDataHealthError
          >
    ): void;
    /** @summary Get Report */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetOfficeDataHealthSchema,
            GetOfficeDataHealthData,
            TInfinite,
            GetOfficeDataHealthParameters,
            GetOfficeDataHealthError
          >
        | QueryFiltersByQueryKey<
            GetOfficeDataHealthSchema,
            GetOfficeDataHealthData,
            TInfinite,
            GetOfficeDataHealthParameters,
            GetOfficeDataHealthError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get Report */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetOfficeDataHealthSchema,
            GetOfficeDataHealthData,
            TInfinite,
            GetOfficeDataHealthParameters,
            GetOfficeDataHealthError
          >
        | QueryFiltersByQueryKey<
            GetOfficeDataHealthSchema,
            GetOfficeDataHealthData,
            TInfinite,
            GetOfficeDataHealthParameters,
            GetOfficeDataHealthError
          >
    ): number;
    schema: GetOfficeDataHealthSchema;
    types: {
      parameters: GetOfficeDataHealthParameters;
      data: GetOfficeDataHealthData;
      error: GetOfficeDataHealthError;
    };
  };
  /** @summary List Check Items */
  listOfficeDataHealthItems: {
    /** @summary List Check Items */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<ListOfficeDataHealthItemsSchema, ListOfficeDataHealthItemsParameters, TMeta, TSignal>
        | QueryFnOptionsByParameters<ListOfficeDataHealthItemsParameters, TMeta, TSignal>,
      client?: (
        schema: ListOfficeDataHealthItemsSchema,
        options: {
          parameters: ListOfficeDataHealthItemsParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<ListOfficeDataHealthItemsData, ListOfficeDataHealthItemsError>>
    ): Promise<RequestFnResponse<ListOfficeDataHealthItemsData, ListOfficeDataHealthItemsError>>;
    /** @summary List Check Items */
    getQueryKey(
      parameters: DeepReadonly<ListOfficeDataHealthItemsParameters>
    ): ServiceOperationQueryKey<ListOfficeDataHealthItemsSchema, ListOfficeDataHealthItemsParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Check Items
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.officeDataHealthService.listOfficeDataHealthItems.useQuery({
     *     path: {
     *         office_id: officeId,
     *         check_id: checkId
     *     },
     *     query: {
     *         limit: limit
     *     }
     * })
     * ```
     */
    useQuery<TData = ListOfficeDataHealthItemsData>(
      parameters:
        | ServiceOperationQueryKey<ListOfficeDataHealthItemsSchema, ListOfficeDataHealthItemsParameters>
        | DeepReadonly<ListOfficeDataHealthItemsParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          ListOfficeDataHealthItemsData,
          ListOfficeDataHealthItemsError,
          TData,
          ServiceOperationQueryKey<ListOfficeDataHealthItemsSchema, ListOfficeDataHealthItemsParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ListOfficeDataHealthItemsError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Check Items
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.officeDataHealthService.listOfficeDataHealthItems.useQuery({
     *     path: {
     *         office_id: officeId,
     *         check_id: checkId
     *     },
     *     query: {
     *         limit: limit
     *     }
     * })
     * ```
     */
    useQuery<TData = ListOfficeDataHealthItemsData>(
      parameters:
        | ServiceOperationQueryKey<ListOfficeDataHealthItemsSchema, ListOfficeDataHealthItemsParameters>
        | DeepReadonly<ListOfficeDataHealthItemsParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          ListOfficeDataHealthItemsData,
          ListOfficeDataHealthItemsError,
          TData,
          ServiceOperationQueryKey<ListOfficeDataHealthItemsSchema, ListOfficeDataHealthItemsParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ListOfficeDataHealthItemsError>>;
    /** @summary List Check Items */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListOfficeDataHealthItemsParameters>
    ): ServiceOperationInfiniteQueryKey<ListOfficeDataHealthItemsSchema, ListOfficeDataHealthItemsParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Check Items
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.officeDataHealthService.listOfficeDataHealthItems.useInfiniteQuery({
     *     path: {
     *         office_id: officeId,
     *         check_id: checkId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             limit: initialLimit
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListOfficeDataHealthItemsParameters,
      TQueryFnData = ListOfficeDataHealthItemsData,
      TData = OperationInfiniteData<TQueryFnData, ListOfficeDataHealthItemsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListOfficeDataHealthItemsSchema, ListOfficeDataHealthItemsParameters>
        | DeepReadonly<ListOfficeDataHealthItemsParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListOfficeDataHealthItemsError,
          TData,
          ServiceOperationInfiniteQueryKey<ListOfficeDataHealthItemsSchema, ListOfficeDataHealthItemsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ListOfficeDataHealthItemsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Check Items
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.officeDataHealthService.listOfficeDataHealthItems.useInfiniteQuery({
     *     path: {
     *         office_id: officeId,
     *         check_id: checkId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             limit: initialLimit
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListOfficeDataHealthItemsParameters,
      TQueryFnData = ListOfficeDataHealthItemsData,
      TData = OperationInfiniteData<TQueryFnData, ListOfficeDataHealthItemsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListOfficeDataHealthItemsSchema, ListOfficeDataHealthItemsParameters>
        | DeepReadonly<ListOfficeDataHealthItemsParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListOfficeDataHealthItemsError,
          TData,
          ServiceOperationInfiniteQueryKey<ListOfficeDataHealthItemsSchema, ListOfficeDataHealthItemsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListOfficeDataHealthItemsData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ListOfficeDataHealthItemsError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary List Check Items
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listOfficeDataHealthItemsTotal = qraft.officeDataHealthService.listOfficeDataHealthItems.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const listOfficeDataHealthItemsByParametersTotal = qraft.officeDataHealthService.listOfficeDataHealthItems.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             office_id: officeId,
     *             check_id: checkId
     *         },
     *         query: {
     *             limit: limit
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListOfficeDataHealthItemsSchema,
            ListOfficeDataHealthItemsData,
            TInfinite,
            ListOfficeDataHealthItemsParameters,
            ListOfficeDataHealthItemsError
          >
        | QueryFiltersByQueryKey<
            ListOfficeDataHealthItemsSchema,
            ListOfficeDataHealthItemsData,
            TInfinite,
            ListOfficeDataHealthItemsParameters,
            ListOfficeDataHealthItemsError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary List Check Items
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listOfficeDataHealthItemsResults = qraft.officeDataHealthService.listOfficeDataHealthItems.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1,
     *                 check_id: checkId1
     *             },
     *             query: {
     *                 limit: limit1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2,
     *                 check_id: checkId2
     *             },
     *             query: {
     *                 limit: limit2
     *             }
     *         }
     *     ]
     * });
     * listOfficeDataHealthItemsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listOfficeDataHealthItemsCombinedResults = qraft.officeDataHealthService.listOfficeDataHealthItems.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1,
     *                 check_id: checkId1
     *             },
     *             query: {
     *                 limit: limit1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2,
     *                 check_id: checkId2
     *             },
     *             query: {
     *                 limit: limit2
     *             }
     *         }
     *     ]
     * });
     * listOfficeDataHealthItemsCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ListOfficeDataHealthItemsSchema,
          ListOfficeDataHealthItemsParameters,
          ListOfficeDataHealthItemsData,
          ListOfficeDataHealthItemsError
        >
      >,
      TCombinedResult = Array<UseQueryResult<ListOfficeDataHealthItemsData, ListOfficeDataHealthItemsError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<ListOfficeDataHealthItemsData, ListOfficeDataHealthItemsError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary List Check Items
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.officeDataHealthService.listOfficeDataHealthItems.useSuspenseQuery({
     *     path: {
     *         office_id: officeId,
     *         check_id: checkId
     *     },
     *     query: {
     *         limit: limit
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = ListOfficeDataHealthItemsData>(
      parameters:
        | ServiceOperationQueryKey<ListOfficeDataHealthItemsSchema, ListOfficeDataHealthItemsParameters>
        | DeepReadonly<ListOfficeDataHealthItemsParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          ListOfficeDataHealthItemsData,
          ListOfficeDataHealthItemsError,
          TData,
          ServiceOperationQueryKey<ListOfficeDataHealthItemsSchema, ListOfficeDataHealthItemsParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ListOfficeDataHealthItemsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary List Check Items
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.officeDataHealthService.listOfficeDataHealthItems.useSuspenseInfiniteQuery({
     *     path: {
     *         office_id: officeId,
     *         check_id: checkId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             limit: initialLimit
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends ListOfficeDataHealthItemsParameters,
      TData = ListOfficeDataHealthItemsData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListOfficeDataHealthItemsSchema, ListOfficeDataHealthItemsParameters>
        | DeepReadonly<ListOfficeDataHealthItemsParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListOfficeDataHealthItemsData,
          ListOfficeDataHealthItemsError,
          OperationInfiniteData<TData, ListOfficeDataHealthItemsParameters>,
          ServiceOperationInfiniteQueryKey<ListOfficeDataHealthItemsSchema, ListOfficeDataHealthItemsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListOfficeDataHealthItemsData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListOfficeDataHealthItemsParameters>,
      OperationError<ListOfficeDataHealthItemsError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary List Check Items
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listOfficeDataHealthItemsData = qraft.officeDataHealthService.listOfficeDataHealthItems.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1,
     *                 check_id: checkId1
     *             },
     *             query: {
     *                 limit: limit1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2,
     *                 check_id: checkId2
     *             },
     *             query: {
     *                 limit: limit2
     *             }
     *         }
     *     ]
     * });
     * listOfficeDataHealthItemsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listOfficeDataHealthItemsCombinedData = qraft.officeDataHealthService.listOfficeDataHealthItems.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 office_id: officeId1,
     *                 check_id: checkId1
     *             },
     *             query: {
     *                 limit: limit1
     *             }
     *         },
     *         {
     *             path: {
     *                 office_id: officeId2,
     *                 check_id: checkId2
     *             },
     *             query: {
     *                 limit: limit2
     *             }
     *         }
     *     ]
     * });
     * listOfficeDataHealthItemsCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ListOfficeDataHealthItemsSchema,
          ListOfficeDataHealthItemsParameters,
          ListOfficeDataHealthItemsData,
          ListOfficeDataHealthItemsError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<ListOfficeDataHealthItemsData, ListOfficeDataHealthItemsError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<UseSuspenseQueryResult<ListOfficeDataHealthItemsData, ListOfficeDataHealthItemsError>, 'data'>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary List Check Items */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListOfficeDataHealthItemsSchema,
        ListOfficeDataHealthItemsData,
        ListOfficeDataHealthItemsParameters,
        ListOfficeDataHealthItemsError
      >
    ): Promise<ListOfficeDataHealthItemsData>;
    /** @summary List Check Items */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListOfficeDataHealthItemsSchema,
        ListOfficeDataHealthItemsData,
        ListOfficeDataHealthItemsParameters,
        ListOfficeDataHealthItemsError
      >
    ): Promise<void>;
    /** @summary List Check Items */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListOfficeDataHealthItemsSchema,
        ListOfficeDataHealthItemsData,
        ListOfficeDataHealthItemsParameters,
        ListOfficeDataHealthItemsError
      >
    ): Promise<ListOfficeDataHealthItemsData>;
    /** @summary List Check Items */
    fetchInfiniteQuery<TPageParam extends ListOfficeDataHealthItemsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListOfficeDataHealthItemsSchema,
        ListOfficeDataHealthItemsData,
        ListOfficeDataHealthItemsParameters,
        DeepReadonly<TPageParam>,
        ListOfficeDataHealthItemsError
      >
    ): Promise<OperationInfiniteData<ListOfficeDataHealthItemsData, ListOfficeDataHealthItemsParameters>>;
    /** @summary List Check Items */
    prefetchInfiniteQuery<TPageParam extends ListOfficeDataHealthItemsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListOfficeDataHealthItemsSchema,
        ListOfficeDataHealthItemsData,
        ListOfficeDataHealthItemsParameters,
        DeepReadonly<TPageParam>,
        ListOfficeDataHealthItemsError
      >
    ): Promise<void>;
    /** @summary List Check Items */
    ensureInfiniteQueryData<TPageParam extends ListOfficeDataHealthItemsParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListOfficeDataHealthItemsSchema,
        ListOfficeDataHealthItemsData,
        ListOfficeDataHealthItemsParameters,
        DeepReadonly<TPageParam>,
        ListOfficeDataHealthItemsError
      >
    ): Promise<OperationInfiniteData<ListOfficeDataHealthItemsData, ListOfficeDataHealthItemsParameters>>;
    /** @summary List Check Items */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<ListOfficeDataHealthItemsSchema, ListOfficeDataHealthItemsParameters>
        | DeepReadonly<ListOfficeDataHealthItemsParameters>
    ): ListOfficeDataHealthItemsData | undefined;
    /** @summary List Check Items */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListOfficeDataHealthItemsSchema, ListOfficeDataHealthItemsParameters>
        | DeepReadonly<ListOfficeDataHealthItemsParameters>
    ): OperationInfiniteData<ListOfficeDataHealthItemsData, ListOfficeDataHealthItemsParameters> | undefined;
    /** @summary List Check Items */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListOfficeDataHealthItemsSchema,
            ListOfficeDataHealthItemsData,
            TInfinite,
            ListOfficeDataHealthItemsParameters,
            ListOfficeDataHealthItemsError
          >
        | QueryFiltersByQueryKey<
            ListOfficeDataHealthItemsSchema,
            ListOfficeDataHealthItemsData,
            TInfinite,
            ListOfficeDataHealthItemsParameters,
            ListOfficeDataHealthItemsError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              ListOfficeDataHealthItemsSchema,
              ListOfficeDataHealthItemsParameters
            >,
            data:
              | NoInfer<OperationInfiniteData<ListOfficeDataHealthItemsData, ListOfficeDataHealthItemsParameters>>
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<ListOfficeDataHealthItemsSchema, ListOfficeDataHealthItemsParameters>,
            data: ListOfficeDataHealthItemsData | undefined,
          ]
        >;
    /** @summary List Check Items */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<ListOfficeDataHealthItemsSchema, ListOfficeDataHealthItemsParameters>
        | DeepReadonly<ListOfficeDataHealthItemsParameters>
    ): QueryState<ListOfficeDataHealthItemsData, ListOfficeDataHealthItemsError> | undefined;
    /** @summary List Check Items */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListOfficeDataHealthItemsParameters>
        | ServiceOperationInfiniteQueryKey<ListOfficeDataHealthItemsSchema, ListOfficeDataHealthItemsParameters>
    ):
      | QueryState<
          OperationInfiniteData<ListOfficeDataHealthItemsData, ListOfficeDataHealthItemsParameters>,
          ListOfficeDataHealthItemsError
        >
      | undefined;
    /** @summary List Check Items */
    setQueryData(
      parameters:
        | DeepReadonly<ListOfficeDataHealthItemsParameters>
        | ServiceOperationQueryKey<ListOfficeDataHealthItemsSchema, ListOfficeDataHealthItemsParameters>,
      updater: Updater<
        NoInfer<ListOfficeDataHealthItemsData> | undefined,
        NoInfer<DeepReadonly<ListOfficeDataHealthItemsData>> | undefined
      >,
      options?: SetDataOptions
    ): ListOfficeDataHealthItemsData | undefined;
    /** @summary List Check Items */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<ListOfficeDataHealthItemsParameters>
        | ServiceOperationInfiniteQueryKey<ListOfficeDataHealthItemsSchema, ListOfficeDataHealthItemsParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<ListOfficeDataHealthItemsData, ListOfficeDataHealthItemsParameters>> | undefined,
        | NoInfer<
            DeepReadonly<OperationInfiniteData<ListOfficeDataHealthItemsData, ListOfficeDataHealthItemsParameters>>
          >
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<ListOfficeDataHealthItemsData, ListOfficeDataHealthItemsParameters> | undefined;
    /** @summary List Check Items */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ListOfficeDataHealthItemsSchema,
            ListOfficeDataHealthItemsData,
            TInfinite,
            ListOfficeDataHealthItemsParameters,
            ListOfficeDataHealthItemsError
          >
        | QueryFiltersByQueryKey<
            ListOfficeDataHealthItemsSchema,
            ListOfficeDataHealthItemsData,
            TInfinite,
            ListOfficeDataHealthItemsParameters,
            ListOfficeDataHealthItemsError
          >,
      updater: Updater<
        NoInfer<ListOfficeDataHealthItemsData> | undefined,
        NoInfer<ListOfficeDataHealthItemsData> | undefined
      >,
      options?: SetDataOptions
    ): Array<ListOfficeDataHealthItemsData | undefined>;
    /** @summary List Check Items */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListOfficeDataHealthItemsSchema,
        ListOfficeDataHealthItemsData,
        TInfinite,
        ListOfficeDataHealthItemsParameters,
        ListOfficeDataHealthItemsError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary List Check Items */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListOfficeDataHealthItemsSchema,
            ListOfficeDataHealthItemsData,
            TInfinite,
            ListOfficeDataHealthItemsParameters,
            ListOfficeDataHealthItemsError
          >
        | QueryFiltersByQueryKey<
            ListOfficeDataHealthItemsSchema,
            ListOfficeDataHealthItemsData,
            TInfinite,
            ListOfficeDataHealthItemsParameters,
            ListOfficeDataHealthItemsError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary List Check Items */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListOfficeDataHealthItemsSchema,
            ListOfficeDataHealthItemsData,
            TInfinite,
            ListOfficeDataHealthItemsParameters,
            ListOfficeDataHealthItemsError
          >
        | QueryFiltersByQueryKey<
            ListOfficeDataHealthItemsSchema,
            ListOfficeDataHealthItemsData,
            TInfinite,
            ListOfficeDataHealthItemsParameters,
            ListOfficeDataHealthItemsError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary List Check Items */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListOfficeDataHealthItemsSchema,
            ListOfficeDataHealthItemsData,
            TInfinite,
            ListOfficeDataHealthItemsParameters,
            ListOfficeDataHealthItemsError
          >
        | QueryFiltersByQueryKey<
            ListOfficeDataHealthItemsSchema,
            ListOfficeDataHealthItemsData,
            TInfinite,
            ListOfficeDataHealthItemsParameters,
            ListOfficeDataHealthItemsError
          >
    ): void;
    /** @summary List Check Items */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListOfficeDataHealthItemsSchema,
            ListOfficeDataHealthItemsData,
            TInfinite,
            ListOfficeDataHealthItemsParameters,
            ListOfficeDataHealthItemsError
          >
        | QueryFiltersByQueryKey<
            ListOfficeDataHealthItemsSchema,
            ListOfficeDataHealthItemsData,
            TInfinite,
            ListOfficeDataHealthItemsParameters,
            ListOfficeDataHealthItemsError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary List Check Items */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListOfficeDataHealthItemsSchema,
            ListOfficeDataHealthItemsData,
            TInfinite,
            ListOfficeDataHealthItemsParameters,
            ListOfficeDataHealthItemsError
          >
        | QueryFiltersByQueryKey<
            ListOfficeDataHealthItemsSchema,
            ListOfficeDataHealthItemsData,
            TInfinite,
            ListOfficeDataHealthItemsParameters,
            ListOfficeDataHealthItemsError
          >
    ): number;
    schema: ListOfficeDataHealthItemsSchema;
    types: {
      parameters: ListOfficeDataHealthItemsParameters;
      data: ListOfficeDataHealthItemsData;
      error: ListOfficeDataHealthItemsError;
    };
  };
}
/** @summary Get Report */
export const getOfficeDataHealth = {
  schema: {
    method: 'get',
    url: '/offices/{office_id}/data_health',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetOfficeDataHealthSchema;
  [QraftServiceOperationsToken]: OfficeDataHealthService['getOfficeDataHealth'];
};
/** @summary List Check Items */
export const listOfficeDataHealthItems = {
  schema: {
    method: 'get',
    url: '/offices/{office_id}/data_health/{check_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: ListOfficeDataHealthItemsSchema;
  [QraftServiceOperationsToken]: OfficeDataHealthService['listOfficeDataHealthItems'];
};
export const officeDataHealthService = {
  getOfficeDataHealth,
  listOfficeDataHealthItems,
} as const;
type GetOfficeDataHealthSchema = {
  method: 'get';
  url: '/offices/{office_id}/data_health';
  security: ['HTTPBearer'];
};
type GetOfficeDataHealthParameters = paths['/offices/{office_id}/data_health']['get']['parameters'];
type GetOfficeDataHealthData =
  paths['/offices/{office_id}/data_health']['get']['responses']['200']['content']['application/json'];
type GetOfficeDataHealthError =
  paths['/offices/{office_id}/data_health']['get']['responses']['422']['content']['application/json'];
type ListOfficeDataHealthItemsSchema = {
  method: 'get';
  url: '/offices/{office_id}/data_health/{check_id}';
  security: ['HTTPBearer'];
};
type ListOfficeDataHealthItemsParameters = paths['/offices/{office_id}/data_health/{check_id}']['get']['parameters'];
type ListOfficeDataHealthItemsData =
  paths['/offices/{office_id}/data_health/{check_id}']['get']['responses']['200']['content']['application/json'];
type ListOfficeDataHealthItemsError =
  paths['/offices/{office_id}/data_health/{check_id}']['get']['responses']['422']['content']['application/json'];
